const onBoardingSessionStorageKey = 'pendingOnBoardingPopup';
const sessionStorageKey = 'pendingDynamicSuburbsPopup';

class NotificationPanelController {
    constructor($scope, $state, sessionStorage, settings, expressService, shopperService, loginService, onBoardingService, analytics) {
        this.$scope = $scope;
        this.$state = $state;
        this.sessionStorage = sessionStorage;
        this.settings = settings;
        this.expressService = expressService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.onBoardingService = onBoardingService;
        this.analytics = analytics;
    }

    $onInit() {
        this.shouldDisplayDynamicSuburbDialog = false;
        this.shouldDisplayExpressSelectedDialog = false;
        this.shouldDisplayFulfillmentSelectorDialog = false;
        this.shouldDisplayOnboardingDialog = false;

        this.$scope.$on('login:success', () => {
            this.sessionStorage.set(sessionStorageKey, true);
        });

        if (this.sessionStorage.getAndRemove(sessionStorageKey)) {
            this.showDynamicSuburbsDialog();

            // Feature switch for onboarding
            if (this.settings.content.enableFulfilmentSelectorModal) {
                this.sessionStorage.set(onBoardingSessionStorageKey, true);
            }
        }

        this.showExpressSelectedDialog();

        // Show onboarding screen
        if (this.sessionStorage.getAndRemove(onBoardingSessionStorageKey) &&
            !this.shouldDisplayDynamicSuburbDialog && !this.shouldDisplayExpressSelectedDialog) {
            this.showOnboardingDialog();
        }
    }

    closeOnBoardingDialog() {
        this.showFulfilmentSelectorDialog();
    }

    showOnboardingDialog() {
        this.onBoardingService.getDynamicUserPreferences().then((result) => {
            if (!result.HasDoneOnboarding) {
                this.shouldDisplayOnboardingDialog = true;
            } else {
                this.closeOnBoardingDialog();
            }
        });
    }

    showFulfilmentSelectorDialog() {
        this.shouldDisplayFulfillmentSelectorDialog =
            this.settings.content.enableFulfilmentSelectorModal && !this.shouldDisplayDynamicSuburbDialog && !this.shouldDisplayExpressSelectedDialog;
    }

    showDynamicSuburbsDialog() {
        this.shouldDisplayDynamicSuburbDialog = !this.shopperService.IsGuest &&
            this.shopperService.shopper.ShouldShowDeliveryWindowDialog &&
            this.loginService.loginContext !== 'checkout';

        if (this.shouldDisplayDynamicSuburbDialog) {
            this.analytics.pushEvent('dynamic suburbs popup presented');
        }
    }

    showExpressSelectedDialog() {
        this.shouldDisplayExpressSelectedDialog = this.expressService.shouldShowExpressSelectedDialog() &&
            this.$state.current.name === 'root';
    }
}

NotificationPanelController.$inject = ['$scope', '$state', 'SessionStorageWrapper', 'Settings', 'ExpressService', 'ShopperService', 'LoginService', 'OnBoardingService', 'AnalyticsService'];

const notificationPanelComponentDefinition = {
    controller: NotificationPanelController,
    template: require('./notification-panel.component.html').trim(),
};

module.exports = {
    NotificationPanelController,
    notificationPanelComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/notificationpanel/notification-panel.component.js